import React from "react";
import Logo from "../../assets/icons/CampusLLMLogoSmall.png";

const Support = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a0a0a] via-[#0f0b08] to-[#0a0a0a] flex flex-col items-center justify-center px-6 py-12">
      <div className="max-w-lg w-full">
        <div className="flex flex-col items-center mb-10">
          <img src={Logo} alt="CampusLM Logo" className="h-12 mb-4" />
          <h1 className="text-white text-3xl font-semibold">Support</h1>
          <p className="text-gray-400 text-sm mt-2 text-center">
            We're here to help. Reach out and we'll get back to you as soon as possible.
          </p>
        </div>

        <div className="bg-white/5 border border-white/10 rounded-2xl p-8 space-y-6">
          <div>
            <h2 className="text-white text-lg font-medium mb-1">Contact Us</h2>
            <p className="text-gray-400 text-sm">
              For support inquiries, questions about your account, or general feedback, email us at:
            </p>
            <a
              href="mailto:support@campuslm.com"
              className="block mt-3 text-amber-400 font-medium hover:text-amber-300 transition-colors"
            >
              support@campuslm.com
            </a>
          </div>

          <div className="border-t border-white/10 pt-6">
            <h2 className="text-white text-lg font-medium mb-1">What We Can Help With</h2>
            <ul className="text-gray-400 text-sm space-y-2 mt-3">
              <li>• Account access and login issues</li>
              <li>• Questions about your institution's CampusLM setup</li>
              <li>• Technical problems or bugs</li>
              <li>• Feature requests and feedback</li>
              <li>• Privacy or data inquiries</li>
            </ul>
          </div>

          <div className="border-t border-white/10 pt-6">
            <h2 className="text-white text-lg font-medium mb-1">Response Time</h2>
            <p className="text-gray-400 text-sm">
              We typically respond within 1–2 business days.
            </p>
          </div>
        </div>

        <p className="text-gray-600 text-xs text-center mt-8">
          © {new Date().getFullYear()} CampusLM. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Support;
